<template>
  <div class="dataRetentionTab" v-if="items">
    <router-link
      v-for="(item, index) in items"
      :key="index"
      :to="{ name: item.routerName }"
      @click="changeTab(item)"
      :class="[
        { activeTab: [item.routerName, item.name].includes(selectedItem) },
        'item',
      ]"
    >
      <span>{{ item.name }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'DataRetentionTabs',
  props: {
    selectedItem: { type: String, required: true },
    items: { type: Array, required: true },
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    changeTab(item) {
      this.$emit('onClick', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.dataRetentionTab {
  padding-top: 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: transparent;
  height: 100%;
  align-content: center;
  justify-content: flex-start;
  width: 9.0625em * 3 + 0.125em;
  .health-bar {
    margin-left: auto;
  }
  position: sticky;
  top: 11rem;
  z-index: 97;
  background-color: $bg-primary;
  width: 100%;
}
.activeTab {
  cursor: pointer;
  color: $color-black !important;
  background-color: $color-brand-accent;
  border-right: none !important;
}
.item {
  text-align: center;
  font-size: 0.85rem;
  border: solid 0.0625em $border-primary;
  width: 22em;
  height: 100%;
  text-decoration: none;
  color: $font-primary;
  padding: 0.275em 0.75em;
  margin-bottom: 0.5em;
  &:hover {
    color: $color-brand-accent;
  }

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
